"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
var modal_1 = require("../modal");
var justify_1 = require("../justify");
var button_1 = require("../button");
var i18n_1 = require("../i18n");
var util_1 = require("../util");
/**
 * 图片预览
 */
exports.Video = react_1.default.forwardRef(function Video(props, ref) {
    var classPrefix = config_context_1.useConfig().classPrefix;
    var t = i18n_1.useTranslation();
    var src = props.src, children = props.children, title = props.title, className = props.className, _a = props.style, style = _a === void 0 ? {} : _a, restProps = tslib_1.__rest(props, ["src", "children", "title", "className", "style"]);
    var _b = tslib_1.__read(react_1.useState(false), 2), visible = _b[0], setVisible = _b[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-video", className), style: tslib_1.__assign({ cursor: "pointer" }, style) }, restProps, { onClick: util_1.callBoth(function () { return setVisible(true); }, restProps.onClick) }), children),
        react_1.default.createElement(modal_1.Modal, { disableCloseIcon: true, className: classPrefix + "-dialog--img", visible: visible, onClose: function () { return setVisible(false); }, onExited: function () { return setVisible(false); } },
            react_1.default.createElement("div", { className: classPrefix + "-dialog__header" },
                react_1.default.createElement(justify_1.Justify, { left: react_1.default.createElement("h3", { className: classPrefix + "-dialog__headertitle" }, title), right: react_1.default.createElement(button_1.Button, { type: "icon", icon: "close", htmlType: "button", onClick: function () { return setVisible(false); }, "aria-label": t.closeText }) })),
            react_1.default.createElement(modal_1.Modal.Body, { style: { marginTop: 0 } },
                react_1.default.createElement("iframe", { allowFullScreen: true, src: src, width: 700, height: 500, title: title, style: { backgroundColor: "#000" } })))));
});
exports.Video.displayName = "Video";
//# sourceMappingURL=Video.js.map